import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NavigationEnd, Router} from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-submenu',
  standalone: false,
  templateUrl: './submenu.component.html',
  styleUrl: './submenu.component.css',
  animations: [
    trigger('expandCollapse', [
      state('expanded', style({
        height: '*',
        opacity: 1,
        padding: '*'
      })),
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        padding: '0'
      })),
      transition('expanded <=> collapsed', [
        animate('500ms ease')
      ]),
    ])
  ]
})
export class SubmenuComponent implements OnInit{

  accordionStates: { [key: string]: number } = {}; // store open index for each accordion group

  selectedType: string;
  selectedTitle: string;
  private routerSubscription!: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<SubmenuComponent>,
    private router: Router
  ) {
    this.selectedType = data.selectedType.toLowerCase();
    this.selectedTitle = data.selectedTitle;
  }

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.dialogRef.close();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  updateData(type: string, title: string) {
    this.selectedType = type.toLowerCase();  // normalize
    this.selectedTitle = title;
    this.cdr.detectChanges(); // ensures the view updates
  }

  toggle(group: string, index: number) {
    this.accordionStates[group] =
      this.accordionStates[group] === index ? -1 : index;
  }

}
